// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__BkgSc","rootSmall":"AddTileButton_rootSmall__19U5D"};